module.exports = (className, plural) => {
  var displayName;
  if (isUpper(className)) {
    displayName = className;
  } else {
    displayName = className.replace(/([A-Z])/g, ' $1').trim()
    displayName = displayName.charAt(0).toUpperCase() + displayName.slice(1);
  }
  if (plural) {
    if(className[className.length -1] == 's' || className[className.length -1] == 'S'){
      displayName = displayName + 'es';
    }else if(className[className.length -1] == 'y' || className[className.length -1] == 'Y'){
      displayName = displayName.slice(0, -1) + 'ies';
    }else{
      displayName = displayName + 's';
    }
  }
  return displayName;
};

function isUpper(str) {
  return !/[a-z]/.test(str) && /[A-Z]/.test(str);
}
